import PropTypes from "prop-types";
import styles from "./MainContent.module.scss";

/**
 * Provides standardized content area with consistent styling
 */
const MainContent = ({ 
  children, 
  className = "",
  padding = "default" // "none", "small", "default", "large"
}) => {
  const paddingClass = padding !== "default" ? styles[`padding${padding.charAt(0).toUpperCase() + padding.slice(1)}`] : "";
  
  return (
    <div className={`${styles.mainContent} ${paddingClass} ${className}`}>
      {children}
    </div>
  );
};

MainContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  padding: PropTypes.oneOf(["none", "small", "default", "large"]),
};

export default MainContent;
